import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAppState } from '../../state';

export default function PrivateRoute({ children, ...rest }: RouteProps) {
  const { isAuthReady, profile } = useAppState();

  console.log('PrivateRoute ' + isAuthReady + ' ' + profile);
  if (!profile && !isAuthReady) {
    return null;
  }
  if (!profile) {
    window.location.pathname = '/api/signin';
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        profile ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/api/signin',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
